export class StoresSearchBoxChangedUseCase {
    public execute = async () => {
        return;
    };
}
